import React, { useState } from 'react'
import { EyeCloseIcon } from '../../../assets/icons'
import './Input.css'

const Input = ({
    readOnly = false,
    error = '',
    name,
    value,
    center,
    theme = '',
    type = "text",
    placeholder = '',
    classNameContent = '',
    classNameInput = '',
    autoComplete,
    disabled = false,
    min = 0,
    max,
    onBlur = () => { },
    onFocus = () => { },
    onChange = () => { },
    onClick = () => { },
}) => {

    const [isVisible, setIsVisible] = useState(type !== "password")
    return (
        <div className={classNameContent}>
            <div className='column'>
                <input
                    className={`${classNameInput} input-style ${center ? 'center-input' : ''}`}
                    readOnly={readOnly}
                    type={
                        type !== "password" ? type : isVisible ? "text" : "password"
                    }
                    name={name}
                    value={value}
                    onBlur={onBlur}
                    onChange={onChange}
                    onFocus={onFocus}
                    disabled={disabled}
                    placeholder={placeholder}
                    autoComplete={autoComplete}
                    min={min}
                    max={max}
                    onClick={onClick}
                />

                {
                    type === "password" && (
                        <div className='column centerItems'
                            onClick={() => { setIsVisible(!isVisible) }}
                        >
                            <EyeCloseIcon height={25} />
                        </div>
                    )
                }
            </div>


            {error && <div className={`text-error-input  ${center ? 'center-input' : ''}`}>{error}</div>}
        </div>
    )
}

export default Input